import {
	RECEIVE_USER_ERROR,
	RECEIVE_USER_RESPONSE,
	SEND_USER_REQUEST,
	SET_IS_LOGIN,
} from "./ActionTypes";

const init = {
	loading: false,
	data: null,
	error: "",
};

export const UserReducer = (state = init, action) => {
	switch (action.type) {
		case SEND_USER_REQUEST:
			return { ...state, loading: true };
		case RECEIVE_USER_RESPONSE:
			return { loading: false, data: action.payload, error: "" };
		case RECEIVE_USER_ERROR:
			return { loading: false, data: null, error: action.payload };
		case "UPDATE_USER_MANAGER_STATUS":
			if (state.data && state.data.team_users) {
				const updatedTeamUsers = state.data.team_users.map((user) =>
					user.uid === action.payload.userId
						? { ...user, is_leader: action.payload.isLeader }
						: user,
				);
				return {
					...state,
					data: {
						...state.data,
						team_users: updatedTeamUsers,
					},
				};
			}
			return state;
		default:
			return state;
	}
};

export const IsLoginReducer = (state = false, action) => {
	switch (action.type) {
		case SET_IS_LOGIN:
			return action.payload;
		default:
			return state;
	}
};
